<template>
  <ODialog ref="dialog" :maxWidth="400">
    <v-card>
      <v-card-text class="pa-6">
        <v-text-field label="Nome do item" v-model="row.name" autofocus />

        <OMoneyInput label="Valor" v-model="row.value" />
      </v-card-text>
      <ODialogButtons class="pa-6" @cancel="dismiss" @apply="apply" />
    </v-card>
  </ODialog>
</template>

<script>
import OMoneyInput from 'oderon-vue/cpts/OMoneyInput.vue'

export default {
  components: { OMoneyInput },
  data() {
    return { row: {} }
  },
  methods: {
    open(row) {
      if (row == null) row = {}

      this.row = {
        name: row.name,
        value: row.value
      }

      return this.$refs.dialog.$open()
    },
    dismiss() {
      this.$refs.dialog.$dismiss()
    },
    apply() {
      this.$refs.dialog.$apply(this.row)
    }
  }
}
</script>

<style></style>
